import { publicRequest } from "./requestMethods";

export async function assistantStatus(signal) {
  const { data } = await publicRequest.get("/api/shopping-assistant/status", { signal, timeout: 5000 });
  return Boolean(data?.aiAvailable);
}

export async function askShoppingAssistant(message, history, signal) {
  const { data } = await publicRequest.post("/api/shopping-assistant/query", { message, history }, { signal, timeout: 20000 });
  if (!data?.success) throw new Error("Assistant unavailable");
  return data;
}
